import { render } from "./FactorySettings.vue?vue&type=template&id=cc69cec6"
import script from "./FactorySettings.vue?vue&type=script&lang=js"
export * from "./FactorySettings.vue?vue&type=script&lang=js"

import "./FactorySettings.vue?vue&type=style&index=0&id=cc69cec6&lang=css"
script.render = render

export default script